/**
 * Payment Service API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UserPaymentAccountRoleAddDto { 
    role: UserPaymentAccountRoleAddDto.RoleEnum;
    userAccountId: number;
}
export namespace UserPaymentAccountRoleAddDto {
    export const RoleEnum = {
        Owner: 'OWNER',
        Viewer: 'VIEWER',
        Financial: 'FINANCIAL'
    } as const;
    export type RoleEnum = typeof RoleEnum[keyof typeof RoleEnum];
}


export type RoleEnum = typeof UserPaymentAccountRoleAddDto.RoleEnum[keyof typeof UserPaymentAccountRoleAddDto.RoleEnum];
